import { 
    getLedgerList,
    } from "@/apis/company/ledger.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_ledger_mgt_list: 'ledgerMgt/set_ledger_mgt_list',
    // set_edit_ledger_obj: 'ledgerMgt/set_edit_ledger_obj',
    set_mode: 'ledgerMgt/set_mode',
    set_filter_query: 'ledgerMgt/set_filter_query',
    set_filter_word: 'ledgerMgt/set_filter_word',
    set_filter_result: 'ledgerMgt/set_filter_result',
    set_filter_default: 'ledgerMgt/set_filter_default',
    set_loading: 'ledgerMgt/set_loading'

}

// count state 必須是 Object
const state = {
    ledgerMgtList: [],
    filterQuery: {
        group: '',
        member: '',
        county: '',
        district: '',
        type: '',
        item: '',
        amount: [0, 100000],
        date: []
    },
    filterWord: '',
    filterResult: [],
    mode: null,
    isDefault: false,
    isLoading: false,
    // editLedgerObj: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LEDGER_MGT_LIST: (state) => {
        return state.ledgerMgtList
    },
    // GET_BIZ_EDIT_LEDGER_OBJ: (state) => {
    //     return state.editLedgerObj
    // },
    GET_BIZ_LEDGER_MGT_MODE: (state) => {
        return state.mode
    },
    GET_BIZ_LEDGER_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_LEDGER_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_LEDGER_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_LEDGER_MGT_INCOME_TOTAL: (state) => {
        let result = state.filterResult
        let amount = 0
        let total  = 0
        for (let i = 0; i < result.length; i++) {
            const element = result[i];
            if( element.ledgerType == 'INCOME'){
                amount += element.amount
                total  += 1
            }
            
        }

        return {total, amount}
    },
    GET_BIZ_LEDGER_MGT_EXPENSE_TOTAL: (state) => {
        let result = state.filterResult
        let amount = 0
        let total  = 0
        for (let i = 0; i < result.length; i++) {
            const element = result[i];
            if( element.ledgerType == 'EXPENSE'){
                amount += element.amount
                total  += 1
            }
            
        }

        return {total, amount}
    },
    GET_BIZ_LEDGER_MGT_ADVANCE_PAYMENT_TOTAL: (state) => {
        let result = state.filterResult
        let amount = 0
        let total  = 0
        for (let i = 0; i < result.length; i++) {
            const element = result[i];
            if( element.ledgerType == 'ADVANCE_PAYMENT'){
                let minusAmountAndQuote = element.quote - element.amount
                amount += minusAmountAndQuote
                total  += 1
            }
            
        }

        return {total, amount}
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLedgerMgtList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            let params = {
                statisticsType: data
            }
            getLedgerList(params)
            .then(res => {
                console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_ledger_mgt_list, res.data.result.houseLedgerList);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizLedgerMgtFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizLedgerMgtFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizLedgerMgtFilterResult ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result, value);
            resolve()
        })
    },
    setBizLedgerMgtFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                group: '',
                member: '',
                county: '',
                district: '',
                type: '',
                item: '',
                amount: [0, 100000],
                date: []
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
    // setBizEditLedger ( {commit}, data ) {
    //     return new Promise((resolve, reject) => {
    //         commit(types.set_edit_ledger_obj, data);
    //         resolve()
    //     })
    // }
}

// mutations
const mutations = {
    [types.set_ledger_mgt_list](state, data){
        state.ledgerMgtList = data
    },
    // [types.set_edit_ledger_obj](state, data){
    //     state.editLedgerObj = data
    // },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result](state, data){
        state.filterResult = data
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/ledgerMgt.js